import Routes from 'Routes';
import { saveOldLocation } from '../../modules/actions';
import { gspCollect } from '@csair/emp-helpers';
import { compare } from 'Utils';

export default store => ({
  path: Routes.ticket.child.coupon.key,
  onEnter(nextState, replace, callback) {
    const { channel, flight, person } = nextState.location.query;
    const {
      App: { oldLocation },
      EdorsedApply: { changeProcess, flightList, psgList },
    } = store.getState();

    const flightArr = flight.split(',').sort(compare);
    const personArr = person.split(',').sort(compare);

    let originSelectFlight = flightList.filter(
      (item, i) => flightArr.indexOf(String(i)) !== -1
    );
    let originSelectpsg = psgList.filter(
      (item, i) => personArr.indexOf(String(i)) !== -1
    );
    window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
      page_name: '机票退改-变更优惠券列表页',
      channel_id: channel ? channel : '',
      ticket_number: originSelectpsg.map(obj => obj.ticketNo).join(';'),
      flight_date: originSelectFlight.map(obj => obj.flightDate).join(';'),
      flight_number: originSelectFlight.map(obj => obj.flightNo).join(';'),
      origin_location: originSelectFlight
        .map(obj => obj.depAirportName)
        .join(';'),
      destination_location: originSelectFlight
        .map(obj => obj.arrAirportName)
        .join(';'),
      passenger_type: originSelectpsg
        .map(obj =>
          obj.psgType === 3
            ? '婴儿'
            : obj.psgType === 1 || obj.psgType === 2
            ? '儿童'
            : '成人'
        )
        .join(';'),
      ticket_refund_type:
        changeProcess && changeProcess[0] && changeProcess[0] === 'zybg'
          ? '自愿变更'
          : '非自愿变更',
    });
    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const Container = require('./components/Container').default;
        cb(null, Container);
      },
      'coupon'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/coupon/index.js